import { render } from "./roomConversation.vue?vue&type=template&id=5ad26dcc&scoped=true"
import script from "./roomConversation.vue?vue&type=script&lang=js"
export * from "./roomConversation.vue?vue&type=script&lang=js"

import "./roomConversation.vue?vue&type=style&index=0&id=5ad26dcc&scoped=true&lang=css"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad26dcc"]])

export default __exports__